import { render } from "./CalculatorExpensesSection.vue?vue&type=template&id=25cc17ba&scoped=true&ts=true&lang=pug"
import script from "./CalculatorExpensesSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalculatorExpensesSection.vue?vue&type=script&lang=ts&setup=true"

import "./CalculatorExpensesSection.vue?vue&type=style&index=0&id=25cc17ba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cc17ba"]])

export default __exports__